import { Component, ElementRef,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  AfterViewInit} from '@angular/core';
  import { MasterService } from "../../Shared/app.Masters.Service";
  import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
  import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
  import { LosService } from "../../_LOS/services/los.service";
  import { SnackbarComponent } from "../../snackbar/snackbar.component";
  import { set } from 'core-js/core/dict';
  declare var $: any;


@Component({
  selector: 'app-digilocker-sdk',
  templateUrl: './digilocker-sdk.component.html',
  styleUrls: ['./digilocker-sdk.component.scss']
})
export class DigilockerSdkComponent implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Output() action: EventEmitter<any> = new EventEmitter<any>();
  // @Input() modalId: string = "modalId"; 
  // @Input() wedsdkModalId: string = "openingWedsdkModal";
  @Input() openmodel: any;
  APIResponse: any;
  SDKAPIResponse: any;
  token: any;
  client_id: string = "";
  showSpinner: boolean = false;
  statusMessage: string = "";
  verify_DocNumber: string = "";
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  istokenavailable: boolean = false;
  currentUser: any;
  constructor(
    private _MasterService: MasterService,
    private snackBar: MatSnackBar,
    private losService: LosService,


  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  openDigilockerModal() {
    this.Digilocker_KYC_Verification();
    // $(`#DigilockerMethodModal`).modal("show");
     $(`#wedsdkModal`).modal("show");
      }
  opendigiboostsdk() {
  $(`#wedsdkModal`).modal("show");

}
  

  Digilocker_KYC_Verification() {
    
    this._MasterService
      .InitDigiBoost()
      .subscribe((res: any) => {
          const APIResult = res.data;
          const response = res;

          this.token = APIResult.token;
          console.log("DigiBoost Token", this.token);
          this.client_id = APIResult.client_id;

          if (response.success == true) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response.message,
              ...this.configSuccess,
            });
            
            this.launchDigilockerKYC();
            return;
          }
          
          
      });
   
  }

  private cleanupDigiboostUI(): void {
    const modal = document.querySelector('.digiboost-modal');
    const buttonWrapper = document.querySelector('#digilocker-button');

    if (modal) modal.remove();
    if (buttonWrapper) buttonWrapper.innerHTML = ''; // clear any leftover buttons

    const statusElement = document.getElementById('status');
    if (statusElement) statusElement.innerHTML = '';
    

  }
loadDigiboostSdk(): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    // script.src = script.src = "https://cdn.jsdelivr.net/gh/surepassio/surepass-digiboost-web-sdk@latest/index.min.js"; // ✅ correct CDN
    script.src = `https://cdn.jsdelivr.net/gh/surepassio/surepass-digiboost-web-sdk@latest/index.min.js?ts=${Date.now()}`;

    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject('Failed to load DigiBoost SDK');
    document.body.appendChild(script);
  });
}


  launchDigilockerKYC() {
   this.cleanupDigiboostUI();
  this.loadDigiboostSdk()
    .then(() => {
      console.log("this", this.token);
      //  $(`#DigilockerMethodModal`).modal("show");
      (window as any).DigiboostSdk({
        
        gateway: "production", // or "production"
        token: this.token, 
        selector: "#digilocker-button",
        style: {
          backgroundColor: "#2196F3",
          color: "white",
          padding: "12px 24px",
          borderRadius: "25px",
          fontSize: "14px",
          fontWeight: "600",
          boxShadow: "0 2px 4px rgba(33, 150, 243, 0.3)",
          transition: "all 0.2s ease"
        },
        
        onSuccess: (data: any) => {
          console.log("✅ Verification successful:", data);
          document.getElementById("status")!.innerHTML =
            '<div class="success">✅ Verification completed successfully!</div>';
            setTimeout(() => {
              this.onclosewebsdkModal();
              this.onCloseDigilockerMethodModal();
            }, 3000);

          this.DownloadDigiLockerDocument();
            
        },
        onFailure: (error: any) => {
          console.error("❌ Verification failed:", error);
          document.getElementById("status")!.innerHTML =
            '<div class="error">❌ Verification failed or was cancelled</div>';
          var dataonfail = {
            KYC_Verification: {
              DoucumentNumber: this.verify_DocNumber,
              DocumentId: 6,
              IsVerified: false,
              APIURL: "https://kyc-api.surepass.app/api/v1/digilocker/download-aadhaar/digilocker_CLIENT_ID",
              APIRequest: "",
              APIResponse: JSON.stringify(error),
              APIStatus: error.status_code || 400,
              LoginUserId: this.currentUser.userId,
              SenderId: "SurePass"
            },
          };
          console.log("DigiBoost Save_Json on fail", dataonfail);
          this._MasterService
          .Save_Customer_Kyc_Verification({ JSON: JSON.stringify(dataonfail) })
          .subscribe();
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No document found for the selected type.",
            ...this.configSuccess,
          });
          
            
            
            
        }
      });
    })
    .catch((err) => {
      console.error("Failed to load DigiBoost SDK", err);
      alert("DigiBoost SDK could not be loaded. Please try again later.");
    });
}


 
  onclosewebsdkModal() {
    $(`#wedsdkModal`).modal("hide");
    console.log("Web SDK Modal closed");
    // this.onCloseDigilockerMethodModal()
  }
  onCloseDigilockerMethodModal() {
    this.showSpinner = false;
    $(`#DigilockerMethodModal`).modal("hide");
    
  }

  DownloadDigiLockerDocument() {
    this.showSpinner = true;
    var model = {
      client_id: this.client_id,
    };
    this._MasterService.DownloadDigiLockerDocs(model).subscribe((res: any) => {
      this.showSpinner = false;
      var response = res;
      var APIResult = res.data;
      if (response.status_code == 200) {
                  this.showSpinner = false;
                  if (response.success == true) {
                    $(`#DigilockerMethodModal`).modal("hide");
                    this.snackBar.openFromComponent(SnackbarComponent, {
                      data: "YOUR KYC INITIATED SUCCESSFULLY !!!",
                      ...this.configSuccess,
                    });
                    this.close.emit({success: true, data: response, openlink: this.openmodel});
                    
                  }
                  else {
                    this.showSpinner = false;
                    //this.CustomerKYCDoc[this.record].KYC_IsVerified = 0;
                    this.snackBar.openFromComponent(SnackbarComponent, {
                      data: "YOUR KYC NOT VALID !!!",
                      ...this.configSuccess,
                    });
                    return;
                  }
                }
      
      if (res != null && res != undefined) {
        console.log("DigiLocker Document Response", res);
            
         var data = {
              KYC_Verification: {
                APIResponse: JSON.stringify(response),
              },
            };
            this.APIResponse = {
                KYC_DocId: 6,
                DoucumentNumber: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.masked_aadhaar,
                Full_name: JSON.parse(data.KYC_Verification.APIResponse).data.digilocker_metadata
                  .name,
                IsVerified: JSON.parse(data.KYC_Verification.APIResponse)
                  .success,
                dob: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.dob,
                gender: JSON.parse(data.KYC_Verification.APIResponse).data.digilocker_metadata
                  .gender,


                country: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.address.country,
                dist: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.address
                  .dist,
                state: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.address.state,
                po: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.address.po,
                loc: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.address.loc,
                vtc: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.address.vtc,
                subdist: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.address.subdist,
                street: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.address.street,
                house: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.address.house,
                landmark: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.address.landmark,
                Pin: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.zip,
                profile_image: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.profile_image,

                zip: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.zip,
                care_of: JSON.parse(data.KYC_Verification.APIResponse).data.aadhaar_xml_data.care_of,
              };
            console.log("DigiBoost Save_Json", data);
            
      } 
    });
  }

}

